import PropTypes from 'prop-types';

const catSplitAttrsType = PropTypes.objectOf(PropTypes.string);

export default catSplitAttrsType;



// WEBPACK FOOTER //
// ./src/components/common/types/catSplitAttrsType.js